const MATCH_US = /^(1)?(\d{3})(\d{3})(\d{4})$/
const MATCH_AU = /^(61)?(\d{1})(\d{4})(\d{4})$/
const MATCH_IE = /^(353)(\d{2})(\d{3})(\d{4})$/
const MATCH_IT_TWELVE = /^(39)?(\d{2})(\d{7})$/
const MATCH_IT_THIRTEEN = /^(39)?(\d{3})(\d{3})(\d{2})(\d{2})$/
const MATCH_NZ_TEN = /^(64)?(\d{1})(\d{3})(\d{4})$/
const MATCH_NZ_ELEVEN = /^(64)?(\d{3})(\d{3})(\d{3})$/
const MATCH_NZ_TWELVE = /^(64)?(\d{3})(\d{3})(\d{4})$/
const MATCH_ZA = /^(27)?(\d{2})(\d{3})(\d{4})$/

const rmNonDigitChars = number => (`${number}`).replace(/\D/g, '')

export function formatTimestamp(timestamp) {
  if (!timestamp || !new Date(timestamp).toJSON()) {
    return null
  }
  const time = timestamp.split('T')
  return `${time[0]} ${time[1].substring(0, 5)} UTC`
}

const formatPhoneNumberForDisplayUS = (number) => {
  const matchUS = number.match(MATCH_US)

  return !matchUS ?
    number :
    matchUS.slice(2).join(' ')
}

const formatPhoneNumberForDisplayAU = (number) => {
  const matchAU = number.match(MATCH_AU)

  return !matchAU ?
    number :
    matchAU.slice(1).join(' ')
}

const formatPhoneNumberForDisplayIE = (number) => {
  const matchIE = number.match(MATCH_IE)

  return !matchIE ?
    number :
    matchIE.slice(1).join(' ')
}

const formatPhoneNumberForDisplayIT = (number) => {
  const matchIT12 = number.match(MATCH_IT_TWELVE)
  const matchIT13 = number.match(MATCH_IT_THIRTEEN)
  if (matchIT12) return matchIT12.slice(1).join(' ')
  else if (matchIT13) return matchIT13.slice(1).join(' ')
  return number
}

const formatPhoneNumberForDisplayNZ = (number) => {
  const matchNZ10 = number.match(MATCH_NZ_TEN)
  const matchNZ11 = number.match(MATCH_NZ_ELEVEN)
  const matchNZ12 = number.match(MATCH_NZ_TWELVE)

  if (matchNZ10) {
    return matchNZ10.slice(1).join(' ')
  } else if (matchNZ11) {
    return matchNZ11.slice(1).join(' ')
  } else if (matchNZ12) {
    return matchNZ12.slice(1).join(' ')
  }
  return number
}

const formatPhoneNumberForDisplayZA = (number) => {
  const matchZA = number.match(MATCH_ZA)

  return !matchZA ?
    number :
    matchZA.slice(1).join(' ')
}

// for when you already know the country code and don't want to interpret phone
// numbers for an audience in another country
export function choosePhoneNumberFormatter(countryCode) {
  switch (countryCode) {
    case 'US': {
      return (num) => {
        const digits = rmNonDigitChars(num)
        return formatPhoneNumberForDisplayUS(digits)
      }
    }
    case 'AU': {
      return (num) => {
        const digits = rmNonDigitChars(num)
        return formatPhoneNumberForDisplayAU(digits)
      }
    }
    case 'IE': {
      return (num) => {
        const digits = rmNonDigitChars(num)
        return formatPhoneNumberForDisplayIE(digits)
      }
    }
    case 'IT': {
      return (num) => {
        const digits = rmNonDigitChars(num)
        return formatPhoneNumberForDisplayIT(digits)
      }
    }
    case 'NZ': {
      return (num) => {
        const digits = rmNonDigitChars(num)
        return formatPhoneNumberForDisplayNZ(digits)
      }
    }
    case 'ZA': {
      return (num) => {
        const digits = rmNonDigitChars(num)
        return formatPhoneNumberForDisplayZA(digits)
      }
    }
    default: {
      return num => num
    }
  }
}

// for when you don't know the country code
export function formatPhoneNumberForDisplay(number) {
  const justDigits = rmNonDigitChars(number)

  const attemptUS = formatPhoneNumberForDisplayUS(justDigits)
  if (attemptUS !== justDigits) {
    return attemptUS
  }

  const attemptAU = formatPhoneNumberForDisplayAU(justDigits)
  if (attemptAU !== justDigits) {
    return attemptAU
  }

  const attemptIE = formatPhoneNumberForDisplayIE(justDigits)
  if (attemptIE !== justDigits) {
    return attemptIE
  }

  const attemptIT = formatPhoneNumberForDisplayIT(justDigits)
  if (attemptIT !== justDigits) {
    return attemptIT
  }

  const attemptZA = formatPhoneNumberForDisplayZA(justDigits)
  if (attemptZA !== justDigits) {
    return attemptZA
  }

  const attemptNZ = formatPhoneNumberForDisplayNZ(justDigits)
  return attemptNZ !== justDigits ? attemptNZ : number
}

export function formatPhoneNumberForUpdate(number) {
  const justDigits = rmNonDigitChars(number)

  const match = justDigits.match(/^(1)?(\d{10})$/)
  return (!match) ? number : `+1${match[2]}`
}



// WEBPACK FOOTER //
// ./src/services/formatters.js